import {Text, View} from "@react-pdf/renderer";
import React, {useContext} from "react";
import {baseStyles} from "../styles";
import {PDFContext} from "../BasePDF";

export const VehicleInfoPDF = () => {
    const pdfData = useContext(PDFContext)
    if (!pdfData) return null;
    const car = pdfData.car_detail
    const location = pdfData.location

    return (
        <View style={{...baseStyles.table}}>
            <View style={{...baseStyles.tableHeader, backgroundColor: pdfData.pageColor}}>
                <Text>Vehicle Info</Text>
            </View>

            <View
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'start',
                    justifyContent: 'space-between',
                    padding: '5px 10px'
                }}
            >
                <View
                    style={{...baseStyles.vehicleInfoContainer}}
                >
                    <Text
                        style={{...baseStyles.vehicleInfoLabel}}
                    >
                        Vehicle:
                    </Text>
                    <Text
                        style={{...baseStyles.vehicleInfo}}
                    >
                        {car.year} {car.make} {car.model} {car.trim} {car.style_description} [{car.manufacture_code}]
                    </Text>
                </View>
                <View
                    style={{...baseStyles.vehicleInfoContainer}}
                >
                    <Text
                        style={{...baseStyles.vehicleInfoLabel}}
                    >
                        Lender:
                    </Text>
                    <Text
                        style={{
                            ...baseStyles.vehicleInfo,
                            textOverflow: 'wrap',
                            width: '100%'
                        }}
                    >
                        { pdfData.program_description }
                    </Text>
                </View>
                <View
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'start',
                        justifyContent: 'space-between',
                    }}
                >
                    <View>
                        <View
                            style={{...baseStyles.vehicleInfoContainer}}
                        >
                            <Text
                                style={{...baseStyles.vehicleInfoLabel}}
                            >
                                Type:
                            </Text>
                            <Text
                                style={{...baseStyles.vehicleInfo}}
                            >
                                <Text>{pdfData.lease_type} - {pdfData.term}</Text>
                            </Text>
                        </View>
                        <View
                            style={{...baseStyles.vehicleInfoContainer}}
                        >
                            <Text
                                style={{...baseStyles.vehicleInfoLabel}}
                            >
                                State:
                            </Text>
                            <Text
                                style={{...baseStyles.vehicleInfo}}
                            >
                                { location.state }
                            </Text>
                        </View>
                    </View>
                    <View>
                        <View
                            style={{...baseStyles.vehicleInfoContainer}}
                        >

                            <Text
                                style={{...baseStyles.vehicleInfoLabel}}
                            >
                                County:
                            </Text>
                            <Text
                                style={{...baseStyles.vehicleInfo}}
                            >
                                { location.county }
                            </Text>
                        </View>
                        <View
                            style={{...baseStyles.vehicleInfoContainer}}
                        >
                            <Text
                                style={{...baseStyles.vehicleInfoLabel}}
                            >
                                City:
                            </Text>
                            <Text
                                style={{...baseStyles.vehicleInfo}}
                            >
                                { location.city }
                            </Text>
                        </View>
                    </View>
                </View>
            </View>
        </View>
    )
}